import { Component, OnInit } from "@angular/core";
import { TableColumn } from "src/@vex/interfaces/table-column.interface";
import icPlay from "@iconify/icons-ic/play-arrow";

@Component({
    selector: "vex-lead-history",
    templateUrl: "./lead-history.component.html",
    styleUrls: ["./lead-history.component.scss"],
})
export class LeadHistoryComponent implements OnInit {
    dataSource = [{}];

    columns: TableColumn<any>[] = [
        {
            label: "Recording",
            property: "recording",
            type: "text",
            visible: true,
            cssClasses: ["text-secondary", "font-medium"],
        },
        {
            label: "Remarks",
            property: "remarks",
            type: "text",
            visible: true,
            cssClasses: ["text-secondary", "font-medium"],
        },
        {
            label: "Recorded On",
            property: "recordedOn",
            type: "text",
            visible: true,
            cssClasses: ["text-secondary", "font-medium"],
        },
    ];

    icPlay = icPlay;

    constructor() {}

    get visibleColumns() {
        return this.columns
            .filter((column) => column.visible)
            .map((column) => column.property);
    }

    ngOnInit(): void {}
}
